import { create } from 'zustand';

export const useTripsVehicleConflictsStore = create((set) => ({

    conflicts: {},

    setConflicts: (vehicleConflicts = {}) => {

        set(state => ({
            conflicts: {
                ...state.conflicts,
                ...vehicleConflicts
            }
        }));

    },

    clearConflicts: () => {

        set({
            conflicts: {}
        });

    }

}));